module.exports = __webpack_public_path__ + "img/icon3.b9637fb9.png";